
import { useApp } from '@/contexts/AppContext';
import { useAuth } from '@/contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import AdminModuleNavigator from './AdminModuleNavigator';
import { DesktopSidebar } from './DesktopSidebar';
import { useIsDesktop } from '@/hooks/use-desktop';
import { cn } from '@/lib/utils';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { state } = useApp();
  const { authenticated } = useAuth();
  const location = useLocation();
  const isDesktop = useIsDesktop();

  // Pages where navigation should NOT be shown
  const hideNavigationPaths = [
    '/',
    '/login',
    '/register',
    '/profile',
    '/survey/pulse',
    '/survey/shape',
    '/coaching/session/1',
    '/coaching/session/2',
    '/coaching/session/3',
    '/coaching/session/4',
    '/coaching/session/new',
    '/profile/edit',
    '/profile/view'
  ];

  // Also hide navigation for survey question pages
  const isSurveyPage = location.pathname.includes('/survey/');
  
  // Check if both assessments are completed
  const assessmentsCompleted = state.assessment && 
    state.assessment.pulseResponses && 
    state.assessment.pulseResponses.length > 0 &&
    state.assessment.shapeResponses && 
    state.assessment.shapeResponses.length > 0;
  
  // Show navigation for /updates if user is authenticated, or if both assessments completed
  const isUpdatesPage = location.pathname === '/updates';
  
  // Show navigation only if user is authenticated and either on updates page or has completed both assessments,
  // and is not on excluded pages or survey pages
  const shouldShowNavigation = authenticated && 
    (isUpdatesPage || assessmentsCompleted) &&
    !hideNavigationPaths.includes(location.pathname) &&
    !isSurveyPage;

  return (
    <div className="min-h-screen bg-white">
      
      {shouldShowNavigation && isDesktop && <DesktopSidebar />}
      <div className={cn(
        "min-h-screen",
        shouldShowNavigation && isDesktop && "lg:ml-64"
      )}>
        {children}
      </div>
      {shouldShowNavigation && <Navigation />}
      <AdminModuleNavigator />
    </div>
  );
};

export default Layout;
